import { render, staticRenderFns } from "./TopRenderedArticleList.vue?vue&type=template&id=ba73690a&"
import script from "./TopRenderedArticleList.vue?vue&type=script&lang=js&"
export * from "./TopRenderedArticleList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports